<template>
  <icon-switch :value='$vuetify.theme.dark' @input='updateTheme' >
    🌛
  </icon-switch>
</template>

<script>
import {useEvent} from '../plugins/vue-gtag';
import IconSwitch from './IconSwitch.vue';
import { getCurrentInstance } from 'vue'

export default {
  components: { IconSwitch },
  setup(_, context){
    const root = getCurrentInstance();
    const vuetify = root.proxy.$vuetify;
    const gaDarkMode = useEvent('darkmode');
    
    const updateTheme = (newVal)=>{
      vuetify.theme.dark = newVal;
      localStorage.setItem("dark_theme", newVal.toString());

      gaDarkMode((newVal) ? 'dark' : 'light');
    } 

    return {
      updateTheme
    }
  }
};
</script>
